import { Component, OnInit, Input, ViewChild, OnChanges, AfterViewInit, SimpleChanges } from '@angular/core';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';
import Chart from '../../../../../../node_modules/chart.js';

@Component({
  selector: 'app-new-business',
  templateUrl: './new-business.component.html',
  styleUrls: ['./new-business.component.css']
})
export class NewBusinessComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(BaseChartDirective, {static: false}) chart: BaseChartDirective;
  @Input() userNewBusiness: any;
  math = Math;
  maxVolume: number;
  newBusiness: any[] = [];
  dataGrafActual: number[] = [];
  copydataGrafActual: number[] = [];
  seccopydataGrafActual: number[] = [];
  dataGrafExpected: number[] = [];
  percent: number[]= [];
  year: number[] = [];
  greenToggle: boolean = true;
  pinkToggle: boolean = true;
  initialBarChartData: any;
  initialDatasets: any;
  public maxValueGraph: number = 30;
  public maxHeight: number = 0;
  public maxValueGraphProc: number = 0;
  public arrayExpected: any[]=[];

  public barChartOptions = {
    scaleShowVerticalLines: false,
    scaleShowValues: false,
    responsive: true,
    hover: {
      mode: 'dataset'
    },
    onHover: function(event){
      event 
    },
    legend: {
      position: 'bottom',
      align: 'center',
      fullWidth: false,
      display: false ,
      labels:{
        boxWidth: 15,
        fontFamily: 'Gerbera',
        padding: 20,
        filter: function(legendItem, data) {
          Chart.defaults.global.legend.display = true
          if(legendItem.datasetIndex == 2){
            return Chart.defaults.global.legend.display = false
          } else{
            return Chart.defaults.global.legend.display = true
          }
        }
      }
    },
    plugins : {
      datalabels: {
        display: false
      }
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
            suggestedMin: 0,
            display:false
          },
          afterBuildTicks: function(context){
            return context.max = context.max * 2
          },
          gridLines: {
            display: false,
            drawBorder: false,
          }
        }
      ],
      xAxes: [
        { 
          ticks:{
            fontFamily: 'Gerbera',
          },
          stacked: true,
          gridLines:{
            display: false
          }
        }
      ]
    }
  };
  public barChartLabels = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
  public barChartType = 'bar';
  public barChartLegend = false;
  public barChartData = [
    {
      data: this.dataGrafActual, 
      label: 'сумма взносов по новым договорам текущего периода, тыс. ₽',
      id: 1
    },
    {
      data: this.dataGrafExpected, 
      label: 'сумма взносов по новым договорам НСЖ текущего периода, тыс. ₽',
      id: 2
    }, 
    {
      data: this.percent,
      label: 'проценты',
      id: 3
    }
  ];
  public barChartColors = [
    {
      backgroundColor: 'rgb(219, 227, 136)'
    },
    {
      backgroundColor: 'rgb(226, 193, 227)' 
    },
    {
      backgroundColor: 'rgba(0,0,0,0)'
    }
  ];
  
  constructor() { }

  ngOnInit() {
    var copydataGrafActual = this.copydataGrafActual;
    var plug = {
      id: 'p1',
      afterDatasetsDraw: function (context, easing) {
        var ctx = context.chart.ctx;
        var modelMaxYE = new Array();
        var modelMaxYA = new Array();
        context.data.datasets.forEach((el)=>{
          if(el.label == 'сумма взносов по новым договорам НСЖ текущего периода, тыс. ₽'){
            // that1.gA = Math.max.apply(Math, el._meta[Object.keys(el._meta)[0]].data.map(function(o) { return o._model.y; }));
            modelMaxYE = el._meta[Object.keys(el._meta)[0]].data.map(function(o) { return !isNaN(o._model.y) ? o._model.y : 0; })
          } else  if(el.label == 'сумма взносов по новым договорам текущего периода, тыс. ₽'){
            // that1.gE = Math.max.apply(Math, el._meta[Object.keys(el._meta)[0]].data.map(function(o) { return o._model.y; }));
            modelMaxYA = el._meta[Object.keys(el._meta)[0]].data.map(function(o) { return !isNaN(o._model.y) ? o._model.y : 0; })
          }
        })
        context.data.datasets.forEach(function (dataset) {
          if(dataset.label == 'сумма взносов по новым договорам НСЖ текущего периода, тыс. ₽' || dataset.label == 'сумма взносов по новым договорам текущего периода, тыс. ₽' || dataset.label == 'проценты')
          for (var i = 0; i < dataset.data.length; i++) {
            var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
            var textY = model.y;
            if(dataset.label == 'сумма взносов по новым договорам НСЖ текущего периода, тыс. ₽'){
              textY = !isNaN(model.y) ? model.y - 30 : 110
              ctx.textAlign = 'center';
              ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
              ctx.fillStyle = '#842D87';
              ctx.save();
              ctx.translate(model.x, textY );
              ctx.fillText("(" + dataset.data[i] + ")", 0, 0);
              ctx.restore();
            } else if(dataset.label == 'сумма взносов по новым договорам текущего периода, тыс. ₽'){  
              textY = !isNaN(model.y) ? model.y : 130
              ctx.textAlign = 'center';
              ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
              ctx.fillStyle = '#ADB837';
              ctx.save();
              var numberof = modelMaxYE.length > 0 && modelMaxYE[i] != 0 ? modelMaxYE[i] - 10 : (modelMaxYE[i] == 0 && modelMaxYA[i] == 0 ? textY : textY - 10);
              ctx.translate(model.x, numberof);
              // var textTepm = context.data.datasets.filter((ef)=> ef.label == 'сумма взносов по новым договорам НСЖ текущего периода, тыс. ₽')[0] == null ?  
              // dataset.data[i] : copydataGrafActual[i];
              ctx.fillText(copydataGrafActual[i], 0, 0);
              ctx.restore();
            } else {
              textY = !isNaN(model.y) ? model.y : 90
              ctx.textAlign = 'center';
              ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
              ctx.fillStyle = '#842D87'
              ctx.save();
              var numberof1 = modelMaxYE.length > 0 && modelMaxYE[i] != 0 ? modelMaxYE[i] - 50 : (modelMaxYA.length > 0 && modelMaxYA[i] != 0 ? modelMaxYA[i] - 30 : textY);
              ctx.translate(model.x, numberof1);
              ctx.fillText(dataset.data[i].toFixed(2) + '%', 0, 0);
              ctx.restore();
            }
          }
        })
      }
    }
    var plugins = Chart.pluginService._plugins.slice(0,4);
    Chart.pluginService.clear();
    plugins.push(plug);
    Chart.pluginService.register(plugins);
  }

  ngAfterViewInit(){
  }

  ngOnChanges() {     
    var gA = 0;
    if(this.userNewBusiness.sales != undefined){
      this.newBusiness = this.userNewBusiness.sales;
      let oldYear = null;
      for(let item of this.newBusiness) {
        if(item.year != oldYear){
          oldYear = item.year;
          this.year.push(item.year);
        }
        
        if(item.year == this.userNewBusiness.sales[0].year){

          let newBusiness = item.new_business_volume != null ? item.new_business_volume / 1000 : 0;
          let newBGusinessnsz = item.new_business_nsz_volume != null ? item.new_business_nsz_volume / 1000 : 0;
          let percentNsz = 0
          if(newBusiness != 0) {
            percentNsz = (newBGusinessnsz / newBusiness) * 100;
          }

         
          
          this.seccopydataGrafActual.push(Math.round(newBusiness) - Math.round(newBGusinessnsz));
          this.copydataGrafActual.push(Math.round(newBusiness));
          this.dataGrafExpected.push(Math.round(newBGusinessnsz));
          this.percent.push(Number(percentNsz.toFixed(2)));
          this.dataGrafActual.push(Math.round(newBusiness) - Math.round(newBGusinessnsz));
          gA = gA == 0 || gA < Math.round(newBusiness) ? Math.round(newBusiness) : gA;
        }
        let that = this;
        this.barChartOptions = {
          scaleShowVerticalLines: false,
          scaleShowValues: false,
          responsive: true,
          hover: {
            mode: 'dataset'
          },
          onHover: function(event){
            event 
          },
          legend: {
            position: 'bottom',
            align: 'start',
            fullWidth: false,
            display: false,
            labels:{
              boxWidth: 15,
              fontFamily: 'Gerbera',
              padding: 20,
              filter: function(legendItem, data) {
                Chart.defaults.global.legend.display = true
                if(legendItem.datasetIndex == 2){
                  return Chart.defaults.global.legend.display = false
                } else{
                  return Chart.defaults.global.legend.display = true
                }
              }
            }
          },
          plugins : {
            datalabels: {
              display: false
            }
          },
          scales: {
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  suggestedMin: 0,
                  display:false
                },
                afterBuildTicks: function(context){
                  return context.max = that.greenToggle == false && that.pinkToggle == false ? 170 : gA * 1.7 ;
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                }
              }
            ],
            xAxes: [
              {
                ticks:{
                  fontFamily: 'Gerbera',
                },
                stacked: true,
                gridLines:{
                  display: false
                }
              }
            ]
          }
        }
      }
      this.initialBarChartData = this.barChartData;
      setTimeout(()=>{
        this.initialDatasets = this.chart.chart.data.datasets
      },2000)
      this.year.reverse();
      this.dataGrafActual.reverse();
      this.copydataGrafActual.reverse();
      this.dataGrafExpected.reverse();
      this.percent.reverse();
      Chart.defaults.global.defaultFontFamily = 'Gerbera';    
    }
  }

  greenLegend(event){
    var classGet = <HTMLElement>event.target.parentNode;
    if(classGet.className == 'greenSquare'){
      classGet = <HTMLElement>classGet.parentNode
    }
    if(classGet.localName == 'ul'){
      classGet = <HTMLElement><ChildNode><unknown>classGet.childNodes[0]
    }
    if(this.greenToggle == true && this.pinkToggle == true){
      this.chart.chart.data.datasets = this.initialDatasets.filter(data => {
        if(data.id == 2){
          return data
        } 
        if(data.id == 3){
          return data
        }
      });
      this.barChartData = this.barChartData.filter(data => {
        if(data.id == 2){
          return data
        } 
        if(data.id == 3){
          return data
        }
      });
      this.greenToggle = false;
      classGet.classList.add('textThrough');

    } else if(this.greenToggle == false && this.pinkToggle == true) {

      this.chart.chart.data.datasets = this.initialDatasets.filter(data => data);
      this.barChartData = this.initialBarChartData.filter(data => data);
      this.barChartData.filter((id)=> id.id == 1)[0].data = this.dataGrafActual
      this.greenToggle = true;
      classGet.classList.remove('textThrough');

    } else if(this.greenToggle == true && this.pinkToggle == false){

      this.chart.chart.data.datasets = this.initialDatasets.filter(data => data);
      this.barChartData = this.initialBarChartData.filter(data => data);
      this.chart.chart.data.datasets = this.chart.chart.data.datasets.filter(data => {
        if(data.id == 3){
          return data
        }
      });
      this.barChartData = this.barChartData.filter(data => {
        if(data.id == 3){
          return data
        }
      });
      this.greenToggle = false;
      classGet.classList.add('textThrough');

    } else if(this.greenToggle == false && this.pinkToggle == false){

      this.chart.chart.data.datasets = this.initialDatasets.filter(data => data);
      this.barChartData = this.initialBarChartData.filter(data => data);
      this.chart.chart.data.datasets = this.chart.chart.data.datasets.filter(data => {
        if(data.id == 1){
          return data
        } 
        if(data.id == 3){
          return data
        }
      })
      this.barChartData = this.barChartData.filter(data => {
        if(data.id == 1){
          this.barChartData.filter((id)=> id.id == 1)[0].data = this.copydataGrafActual
          return data
        } 
        if(data.id == 3){
          return data
        }
      });
      this.greenToggle = true;
      classGet.classList.remove('textThrough');
    }
  }

  pinkLegend(event){
    var classGet = <HTMLElement>event.target.parentNode;
    if(classGet.className == 'pinkSquare'){
      classGet = <HTMLElement>classGet.parentNode
    }
    if(classGet.localName == 'ul'){
      classGet = <HTMLElement><ChildNode><unknown>classGet.childNodes[1]
    }
    if(this.pinkToggle == true && this.greenToggle == true){
      this.chart.chart.data.datasets = this.initialDatasets.filter(data => {
        if(data.id == 1){
          return data
        } 
        if(data.id == 3){
          return data
        }
      });
      this.barChartData = this.barChartData.filter(data => {
        if(data.id == 1){
          this.barChartData.filter((id)=> id.id == 1)[0].data = this.copydataGrafActual
          return data
        } 
        if(data.id == 3){
          return data
        }
      });
      this.pinkToggle = false;
      classGet.classList.add('textThrough');

    } else if(this.pinkToggle == false && this.greenToggle == true) {

      this.chart.chart.data.datasets = this.initialDatasets.filter(data => data);
      this.barChartData = this.initialBarChartData.filter(data => data);
      this.barChartData.filter((id)=> id.id == 1)[0].data = this.dataGrafActual
      this.pinkToggle = true;
      classGet.classList.remove('textThrough');

    } else if(this.pinkToggle == true && this.greenToggle == false) {

      this.chart.chart.data.datasets = this.initialDatasets.filter(data => data);
      this.barChartData = this.initialBarChartData.filter(data => data);
      this.chart.chart.data.datasets = this.chart.chart.data.datasets.filter(data => {
        if(data.id == 3){
          return data
        }
      });
      this.barChartData = this.barChartData.filter(data => {
        if(data.id == 3){
          return data
        }
      });
      this.pinkToggle = false;
      classGet.classList.add('textThrough');

    } else if(this.pinkToggle == false && this.greenToggle == false) {

      this.chart.chart.data.datasets = this.initialDatasets.filter(data => data);
      this.barChartData = this.initialBarChartData.filter(data => data);
      this.chart.chart.data.datasets = this.chart.chart.data.datasets.filter(data => {
        if(data.id == 2){
          return data
        } 
        if(data.id == 3){
          return data
        }
      })
      
      this.barChartData = this.barChartData.filter(data => {
        if(data.id == 2){
          return data
        } 
        if(data.id == 3){
          return data
        }
      });
      this.pinkToggle = true;
      classGet.classList.remove('textThrough');
    } 
  }
}
